import alertComponent from './alertComponent.vue';
import toastComponent from './toastComponent.vue';
const dialogPlugin = {
  install(Vue) {
    const installComponent = { alertComponent, toastComponent };
    Object.keys(installComponent).forEach((name) => {
      const div = document.createElement('div');
      document.body.appendChild(div);
      const VueComponent = Vue.extend(installComponent[name]);
      const instance = (new VueComponent()).$mount(div);

      installComponent[name].install(Vue, instance);
    });
    Vue.prototype.alert = (options) => {
      if (Vue.prototype.$dialogPlugin && Vue.prototype.$dialogPlugin.alert) {
        Vue.prototype.$dialogPlugin.alert(options);
      } else {
        Vue.prototype.$alert(options);
      }
    };
    Vue.prototype.confirm = (options) => {
      if (Vue.prototype.$dialogPlugin && Vue.prototype.$dialogPlugin.confirm) {
        Vue.prototype.$dialogPlugin.confirm(options);
      } else {
        Vue.prototype.$confirm(options);
      }
    };

    Vue.prototype.toast = (options) => {
      if (Vue.prototype.$dialogPlugin && Vue.prototype.$dialogPlugin.toast) {
        Vue.prototype.$dialogPlugin.toast(options);
      } else {
        Vue.prototype.$toast(options);
      }
    };
  },
};

export default dialogPlugin;
